<template>
  <div class="page-stack">
    <div class="sticky-toolbar">
    <a-card :bordered="false" class="sticky-toolbar-card">
      <a-space wrap>
        <div style="font-weight: 600">Дата:</div>

        <a-button @click="shiftDate(-1)"><LeftOutlined /></a-button>
        <a-date-picker
          v-model:value="dateValue"
          format="YYYY-MM-DD"
          :allowClear="false"
          inputReadOnly
          @change="load"
        />
        <a-button @click="shiftDate(1)"><RightOutlined /></a-button>

        <a-button @click="load" :loading="loading">Обновить</a-button>
      </a-space>
    </a-card>
    </div>

    <a-row :gutter="[12, 12]">
      <!-- <a-col :xs="12" :md="3">
        <a-card size="small">
          <a-statistic title="Заказчиков" :value="summary.orders_count || 0" />
        </a-card>
      </a-col> -->

      <a-col :xs="12" :md="3">
        <a-card size="small">
          <a-statistic title="Завтрак" :value="summary.meals.BREAKFAST || 0" />
        </a-card>
      </a-col>

      <a-col :xs="12" :md="3">
        <a-card size="small">
          <a-statistic title="Обед" :value="summary.meals.LUNCH || 0" />
        </a-card>
      </a-col>

      <a-col :xs="12" :md="3">
        <a-card size="small">
          <a-statistic title="Полдник" :value="summary.meals.SNACK || 0" />
        </a-card>
      </a-col>

      <a-col :xs="12" :md="3">
        <a-card size="small">
          <a-statistic title="Ужин" :value="summary.meals.DINNER || 0" />
        </a-card>
      </a-col>
    </a-row>

    <a-card title="Итоги по особым" :bordered="false">
      <a-tabs>
        <a-tab-pane key="BREAKFAST" tab="Завтрак">
          <a-table
            :dataSource="summary.specials.BREAKFAST || []"
            :columns="specialColumns"
            :pagination="false"
            rowKey="id"
            size="small"
          />
        </a-tab-pane>

        <a-tab-pane key="LUNCH" tab="Обед">
          <a-table
            :dataSource="summary.specials.LUNCH || []"
            :columns="specialColumns"
            :pagination="false"
            rowKey="id"
            size="small"
          />
        </a-tab-pane>

        <a-tab-pane key="SNACK" tab="Полдник">
          <a-table
            :dataSource="summary.specials.SNACK || []"
            :columns="specialColumns"
            :pagination="false"
            rowKey="id"
            size="small"
          />
        </a-tab-pane>

        <a-tab-pane key="DINNER" tab="Ужин">
          <a-table
            :dataSource="summary.specials.DINNER || []"
            :columns="specialColumns"
            :pagination="false"
            rowKey="id"
            size="small"
          />
        </a-tab-pane>
      </a-tabs>
    </a-card>

    <a-card title="Заказы" :bordered="false">
      <a-collapse>
        <a-collapse-panel
          v-for="item in orders"
          :key="item.order.id"
        >
          <template #header>
            <div class="order-panel-header">
              <div class="order-panel-main">
                <strong class="order-panel-name">{{ item.contractor.name }}</strong>
              </div>

              <div class="order-panel-stats">
                  <span class="order-stat"><strong>З:</strong> {{ item.meals.BREAKFAST }}</span>
                  <span class="order-stat"><strong>О:</strong> {{ item.meals.LUNCH }}</span>
                  <span class="order-stat"><strong>П:</strong> {{ item.meals.SNACK }}</span>
                  <span class="order-stat"><strong>У:</strong> {{ item.meals.DINNER }}</span>
              </div>

              <div class="order-panel-status">
                <a-tag>{{ label(item.order.status) }}</a-tag>
              </div>
            </div>
          </template>

          <a-space direction="vertical" style="width: 100%" size="middle">
            <a-descriptions :column="1" bordered size="small">
              <a-descriptions-item label="Телефон">
                {{ item.contractor.phone || '—' }}
              </a-descriptions-item>

              <!-- <a-descriptions-item label="Режим special types">
                {{ item.contractor.specials_mode || '—' }}
              </a-descriptions-item> -->

              <a-descriptions-item label="Комментарий">
                {{ item.order.comment || '—' }}
              </a-descriptions-item>
            </a-descriptions>

            <a-row :gutter="[12, 12]">
              <a-col :xs="12" :md="6">
                <a-card size="small" title="Завтрак">
                  <div><strong>Порций:</strong> {{ item.meals.BREAKFAST }}</div>
                  <div style="margin-top: 8px">
                    <strong>Особые:</strong>
                    <div v-if="item.specials.BREAKFAST?.length">
                      <a-tag
                        v-for="sp in item.specials.BREAKFAST"
                        :key="`b-${sp.id}`"
                        style="margin-top: 4px"
                      >
                        {{ sp.name }}: {{ sp.qty }}
                      </a-tag>
                    </div>
                    <div v-else>—</div>
                  </div>
                </a-card>
              </a-col>

              <a-col :xs="12" :md="6">
                <a-card size="small" title="Обед">
                  <div><strong>Порций:</strong> {{ item.meals.LUNCH }}</div>
                  <div style="margin-top: 8px">
                    <strong>Особые:</strong>
                    <div v-if="item.specials.LUNCH?.length">
                      <a-tag
                        v-for="sp in item.specials.LUNCH"
                        :key="`l-${sp.id}`"
                        style="margin-top: 4px"
                      >
                        {{ sp.name }}: {{ sp.qty }}
                      </a-tag>
                    </div>
                    <div v-else>—</div>
                  </div>
                </a-card>
              </a-col>

              <a-col :xs="12" :md="6">
                <a-card size="small" title="Полдник">
                  <div><strong>Порций:</strong> {{ item.meals.SNACK }}</div>
                  <div style="margin-top: 8px">
                    <strong>Особые:</strong>
                    <div v-if="item.specials.SNACK?.length">
                      <a-tag
                        v-for="sp in item.specials.SNACK"
                        :key="`s-${sp.id}`"
                        style="margin-top: 4px"
                      >
                        {{ sp.name }}: {{ sp.qty }}
                      </a-tag>
                    </div>
                    <div v-else>—</div>
                  </div>
                </a-card>
              </a-col>

              <a-col :xs="12" :md="6">
                <a-card size="small" title="Ужин">
                  <div><strong>Порций:</strong> {{ item.meals.DINNER }}</div>
                  <div style="margin-top: 8px">
                    <strong>Особые:</strong>
                    <div v-if="item.specials.DINNER?.length">
                      <a-tag
                        v-for="sp in item.specials.DINNER"
                        :key="`d-${sp.id}`"
                        style="margin-top: 4px"
                      >
                        {{ sp.name }}: {{ sp.qty }}
                      </a-tag>
                    </div>
                    <div v-else>—</div>
                  </div>
                </a-card>
              </a-col>
            </a-row>

            <a-tabs>
              <a-tab-pane key="cb" tab="Завтрак">
                <a-table
                  :dataSource="item.children.BREAKFAST || []"
                  :columns="childColumns"
                  :pagination="false"
                  rowKey="child_id"
                  size="small"
                />
              </a-tab-pane>

              <a-tab-pane key="cl" tab="Обед">
                <a-table
                  :dataSource="item.children.LUNCH || []"
                  :columns="childColumns"
                  :pagination="false"
                  rowKey="child_id"
                  size="small"
                />
              </a-tab-pane>

              <a-tab-pane key="cs" tab="Полдник">
                <a-table
                  :dataSource="item.children.SNACK || []"
                  :columns="childColumns"
                  :pagination="false"
                  rowKey="child_id"
                  size="small"
                />
              </a-tab-pane>

              <a-tab-pane key="cd" tab="Ужин">
                <a-table
                  :dataSource="item.children.DINNER || []"
                  :columns="childColumns"
                  :pagination="false"
                  rowKey="child_id"
                  size="small"
                />
              </a-tab-pane>
            </a-tabs>
          </a-space>
        </a-collapse-panel>
      </a-collapse>
    </a-card>
  </div>
</template>

<script setup>
import { h, ref, computed } from 'vue'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
import { http } from '../../api/http'
import ChildTagIcons from '../../components/ChildTagIcons.vue'
import { label } from '../../utils/labels'

const loading = ref(false)
const raw = ref(null)
const dateValue = ref(dayjs())

const specialColumns = [
  { title: 'Особое', dataIndex: 'name' },
  { title: 'Количество', dataIndex: 'qty' },
]

const childColumns = [
  { title: 'Ребёнок', dataIndex: 'full_name' },
  {
    title: 'Теги',
    dataIndex: 'tags',
    customRender: ({ text }) => h(ChildTagIcons, { tags: text }),
  },
  { title: 'Комментарий', dataIndex: 'child_comment' },
  // { title: 'Примечание', dataIndex: 'order_note' },
]

const summary = computed(() => raw.value?.data?.summary || {
  meals: { BREAKFAST: 0, LUNCH: 0, SNACK: 0, DINNER: 0 },
  specials: { BREAKFAST: [], LUNCH: [], SNACK: [], DINNER: [] },
  orders_count: 0,
})

const orders = computed(() => raw.value?.data?.orders || [])

function dateStr() {
  return dateValue.value.format('YYYY-MM-DD')
}

function shiftDate(days) {
  dateValue.value = dayjs(dateValue.value).add(days, 'day')
  load()
}

async function load() {
  loading.value = true
  try {
    const res = await http.get(`/api/kitchen/day?date=${encodeURIComponent(dateStr())}`)
    raw.value = res.data
  } catch (e) {
    message.error(e?.response?.data?.error?.message || 'Не удалось загрузить данные дня')
  } finally {
    loading.value = false
  }
}

load()
</script>

<style scoped>
.page-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.sticky-toolbar {
  position: sticky;
  top: 16px;
  z-index: 20;
}

.sticky-toolbar-card :deep(.ant-card-body) {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
}

.order-panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.order-panel-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 320px;
  width: 320px;
  min-width: 0;
}

.order-panel-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-panel-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(58px, max-content));
  gap: 12px;
  align-items: center;
  justify-content: start;
  flex: 1 1 auto;
}

.order-stat {
  white-space: nowrap;
  text-align: left;
}

@media (max-width: 767px) {
  .sticky-toolbar-card {
    margin-bottom: 0;
  }

  .sticky-toolbar {
    top: 8px;
  }

  .order-panel-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .order-panel-main {
    width: 100%;
    flex: 1 1 auto;
    flex-wrap: wrap;
  }

  .order-panel-stats {
    grid-template-columns: repeat(2, max-content);
    gap: 8px 14px;
    justify-content: start;
  }
}
</style>
